



































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Mutations, Actions, Buttons } from '@/ts/store/Constants';
import Transactions from '@/components/User/Wallet/Transactions.vue';
import CreditCards from '@/components/User/Wallet/CreditCards.vue';
import AddCreditCardOverlay from '@/components/User/Wallet/AddCreditCardOverlay.vue';
import ChooseAddingPaymentMethodOverlay from '@/components/User/Wallet/ChooseAddingPaymentMethodOverlay.vue';
import CurvedModal from '@/components/Modal/CurvedModal.vue';
import OrderDetails from '@/components/User/Wallet/OrderDetails.vue';
import OrderPay from '@/components/User/Wallet/OrderPay.vue';

@Component({
    components: {
        OrderPay,
        OrderDetails,
        Transactions,
        CreditCards,
        AddCreditCardOverlay,
        ChooseAddingPaymentMethodOverlay,
        CurvedModal,
    },
})

export default class UserWallet extends Vue {

    constructor() {
        super();
    }


    get showWalletBlock() {
        return this.$store.getters['UserWallet/getShowWalletBlock'];
    }

    get showCreditCardsBlock() {
        return this.$store.getters['UserWallet/getShowCreditCardsBlock'];
    }

    get showTransactionsBlock() {
        return this.$store.getters['UserWallet/getShowTransactionsBlock'];
    }

    get cards() {
        return this.$store.getters['CreditCards/getCreditCards'];
    }

    get transactions() {
        return this.$store.getters['UserWallet/getTransactions'];
    }

    get addCreditCardFormVisibility(): boolean {
        return this.$store.getters['CreditCards/getAddNewCardFormVisibility'];
    }

    get choosePaymentMethodBlocKVisibility(): boolean {
        return this.$store.getters['UserWallet/getChoosePaymentMethodBlocKVisibility'];
    }

    public showPaymentMethods() {
        this.$store.commit(Mutations.SET_SHOW_WALLET_BLOCK_VISIBILITY, false);
        this.$store.commit(Mutations.SET_SHOW_CREDIT_CARDS_BLOCK_VISIBILITY, true);
        this.$store.commit(Mutations.SET_SHOW_TRANSACTIONS_BLOCK_VISIBILITY, true);
    }

    public showTransactions() {
        this.$store.commit(Mutations.SET_SHOW_WALLET_BLOCK_VISIBILITY, false);
        this.$store.commit(Mutations.SET_SHOW_TRANSACTIONS_BLOCK_VISIBILITY, true);
    }

    public created() {
        this.$store.commit(Mutations.SET_BOTTOM_MENU_VISIBILITY, false);

        this.$store.dispatch(Actions.FETCH_USER_CREDIT_CARDS);
        this.$store.dispatch(Actions.FETCH_USER_TRANSACTIONS, 'confirmed|reverted');

        this.$store.commit(Mutations.SET_LEFT_HEADER_BUTTON, Buttons.None);
        this.$store.commit(Mutations.SET_RIGHT_HEADER_BUTTON, Buttons.HococoAddButton);
        this.$store.commit(Mutations.SET_ADD_ACTION_BUTTON, Mutations.SET_CHOOSE_PAYMENT_METHOD_BLOCK_VISIBILITY);
        this.$store.commit(Mutations.SET_HEADER_TEXT, this.$t('general.my-wallet', 'My wallet'));
    }

    public mounted() {
        this.$store.commit(Mutations.SET_LEFT_HEADER_BUTTON, 'StaffBackButton');
        this.$store.commit(Mutations.SET_SHOW_WALLET_BLOCK_VISIBILITY, true);
        this.$store.commit(Mutations.SET_SHOW_CREDIT_CARDS_BLOCK_VISIBILITY, false);
        this.$store.commit(Mutations.SET_SHOW_TRANSACTIONS_BLOCK_VISIBILITY, false);
    }

    public destroyed() {
        this.$store.commit(Mutations.SET_BOTTOM_MENU_VISIBILITY, true);
    }
}
